import { render, staticRenderFns } from "./ContactContainer.vue?vue&type=template&id=12ed18e7&scoped=true&"
import script from "./ContactContainer.vue?vue&type=script&lang=js&"
export * from "./ContactContainer.vue?vue&type=script&lang=js&"
import style0 from "./ContactContainer.vue?vue&type=style&index=0&id=12ed18e7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ed18e7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VNavigationDrawer,VTextField})
